import i18n from "./i18n";

export const dropTypes = [
    i18n.t('FILTER_WOODCHIPS_ONLY'),
    i18n.t('FILTER_WOODCHIPS_FEW_LOGS'),
    i18n.t('FILTER_WOODCHIPS_MANY_LOGS'),
    i18n.t('FILTER_ONLY_LOGS')
]